import React from "react";

const CaseCard = ({
  title,
  tag,
  description,
  imageUrl,
  className,
  onClick,
}) => {
  return (
    <div
      className={`group rounded-2xl overflow-hidden text-white relative w-full shadow-lg ${className} h-[583px] flex flex-col  border-2 border-transparent hover:border-zinc-500 transition-all ease-linear duration-300 ${
        onClick ? "cursor-pointer" : ""
      }`}
      onClick={onClick}
    >
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10">
        <img
          src={imageUrl}
          alt="AI Strategy"
          className="w-full h-full object-cover absolute top-0 left-0 transition-all ease-linear duration-300 group-hover:scale-[101%] object-center grayscale"
        />
      </div>
      {/* Spacer to push content to bottom */}
      <div className="flex-grow"></div>

      {tag && (
        <div className="left-0 top-0 flex absolute z-10 m-4 md:m-6">
          <div
            className={`group relative p-[1px] bg-work-tag-border rounded-full transition-all duration-300`}
          >
            <div
              className={`"relative flex items-center gap-2 text-white leading-[140%] font-bold font-theBrittanySans bg-[#555555] rounded-full shadow-[0px_0px_5.6px_1px_#A8A8A8] transition duration-300" px-2 py-1.5 md:px-3 md:py-1 cursor-default`}
            >
              <span className="text-xs md:text-sm">{tag}</span>
              <div className="absolute inset-0 rounded-full border-[1px] border-gray-400/50 blur-md" />
            </div>
          </div>
        </div>
      )}
      <div className="h-20 bg-gradient-to-b from-transparent from-10%  to-[#252525] to-100% z-10"></div>
      <div className="flex flex-col items-start px-4 md:px-6 pt-4 md:pt-8 pb-10 md:pb-14 bg-[#252525] rounded-b-xl relative z-10">
        <h2 className="text-base font-bold font-theBrittanySans">{title}</h2>
        <p className="text-2xl font-medium mt-2">{description}</p>
      </div>
    </div>
  );
};

export default CaseCard;
